"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.21.0
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { useState, useMemo, useEffect, createContext, useContext } from 'react';
import { useComboBox } from './combobox-context.mjs';

const ComboBoxDropdownSearchContext = createContext({
  hideSearch: false,
  dropdownSearchInputValue: "",
  setDropdownSearchInputValue: () => null,
  searchSource: "indeterminate",
  setSearchSource: () => {
  }
});
ComboBoxDropdownSearchContext.displayName = "ComboBoxDropdownSearchContext";
const ComboBoxDropdownSearchProvider = ({
  children,
  hideSearch = false
}) => {
  const [dropdownSearchInputValue, setDropdownSearchInputValue] = useState("");
  const [searchSource, setSearchSource] = useState("indeterminate");
  const { isDropdownOpen } = useComboBox();
  const contextValue = useMemo(
    () => ({
      dropdownSearchInputValue,
      setDropdownSearchInputValue,
      hideSearch,
      searchSource,
      setSearchSource
    }),
    [dropdownSearchInputValue, hideSearch, searchSource]
  );
  useEffect(() => {
    if (!isDropdownOpen && dropdownSearchInputValue) {
      setDropdownSearchInputValue("");
    }
  }, [isDropdownOpen]);
  return /* @__PURE__ */ jsx(ComboBoxDropdownSearchContext.Provider, { value: contextValue, children });
};
function useComboBoxDropdownSearchContext() {
  return useContext(ComboBoxDropdownSearchContext);
}

export { ComboBoxDropdownSearchProvider, useComboBoxDropdownSearchContext };
